
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { login as reduxLogin } from "../redux/actions/authActions";
import { useAuth } from "../context/AuthContext";
import LogoImg from "../images/images.png";

const Login = () => {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    try {
      const response = await dispatch(reduxLogin(phone, password));

      if (response?.meta?.status) {
        const { access_token, id, name, phone, role } = response.data;

        // Store token and user info in localStorage
        localStorage.setItem("token", access_token);
        localStorage.setItem("userId", id);
        localStorage.setItem("name", name);
        localStorage.setItem("phone", phone);
        localStorage.setItem("role", role);

        login();

        toast.success(response.meta.message || "Login successful");
        navigate("/dashboard");
      } else {
        toast.error(response?.meta?.message || "Invalid phone or password.");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred during login.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex">
      {/* <div className="w-1/2 h-screen flex justify-center items-center bg-black">
        <img className="w-[20%]" src={LogoImg} alt="Logo" />
      </div> */}
      {/* <div className="w-1/2 h-screen flex justify-center items-center bg-white">
  <img className="w-[20%]" src={LogoImg} alt="Logo" />
</div> */}
<div className="w-1/2 h-screen flex flex-col justify-center items-center bg-white">
  <img className="w-[20%] mb-4" src={LogoImg} alt="Logo" />

  <div className="text-center text-black">
    <h1 className="text-lg font-semibold">State Urban Development Agency (SUDA)</h1>
    <h2 className="text-base">Urban Development & Municipal Affairs Department</h2>
    <h3 className="text-base">Govt. of West Bengal</h3>
  </div>
</div>


      {/* <div className="w-1/2 flex flex-col gap-4 justify-center items-center bg-gray-200">
        <div className="w-[80%]">
          <h1 className="text-2xl font-bold">Sign in</h1>
          <p>Sign in to your account</p>
        </div>
        <form
          className="bg-white w-[80%] h-[50%] flex flex-col justify-center items-center gap-4 rounded-2xl"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col justify-center w-[80%]">
            <label htmlFor="phone">Phone</label>
            <input
              id="phone"
              className="py-2 px-2 bg-gray-200 rounded-lg"
              placeholder="9876543211"
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>
          <div className="flex flex-col justify-center w-[80%]">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              className="py-2 px-2 bg-gray-200 rounded-lg"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="bg-black text-white p-2 w-[80%] rounded-md"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Submit"}
          </button>
        </form>
      </div> */}
      <div className="w-1/2 flex flex-col gap-4 justify-center items-center bg-gray-200">
  <div className="w-[80%]">
    <h1 className="text-2xl font-bold">Sign in</h1>
    <p>Sign in to your account</p>
  </div>
  
  <form
    className="bg-white w-[80%] h-[50%] flex flex-col justify-center items-center gap-4 rounded-2xl"
    onSubmit={handleSubmit}
  >
    <div className="flex flex-col justify-center w-[80%]">
      <label htmlFor="phone">Phone</label>
      <input
        id="phone"
        className="py-2 px-2 bg-gray-200 rounded-lg"
        placeholder="9876543211"
        type="text"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        required
      />
    </div>

    {/* Dropdown Added Here */}
    <div className="flex flex-col justify-center w-[80%]">
      <label htmlFor="role">Select Role</label>
      <select
        id="role"
        className="py-2 px-2 bg-gray-200 rounded-lg"
        // value={role}
        // onChange={(e) => setRole(e.target.value)}
        //required
      >
        <option value="">-- Select Role --</option>
        <option value="HR">HR</option>
        <option value="Program Manager">Program Manager</option>
        <option value="Super Admin">Super Admin</option>
      </select>
    </div>

    <div className="flex flex-col justify-center w-[80%]">
      <label htmlFor="password">Password</label>
      <input
        id="password"
        className="py-2 px-2 bg-gray-200 rounded-lg"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
    </div>

    <button
      type="submit"
      className="bg-black text-white p-2 w-[80%] rounded-md"
      disabled={loading}
    >
      {loading ? "Logging in..." : "Submit"}
    </button>
  </form>
</div>

    </div>
  );
};

export default Login;
